export default __webpack_public_path__ + "static/media/squared-corners-3.11aba0f7.webp";